export const SITE_PILOTS_CARD_FRENCH_LOCALE = {
  title: "Pilotes installés sur le site",
};
